export const appointmentTypes: { [key: string]: number } = {
    local: 0,
    online: 1,
};

export const appointmentLocationTypes: { [key: string]: number } = {
    external: -2,
    internal: -1,
};